import { axios, exportAction } from '@/libs/api.request';
import { Response } from '@/types/request.d';

export interface remktSourceData {
    sys_user_id: string;
    remkt_source: string;
    project_id: string;
    source_data: string;
}

/**
 * 记录营销来源
 * @param data
 */
export const recordRemktSource = (data: remktSourceData) => axios.request<Response<any>>({
    url: 'chat/remkt-source/set-remkt-source-log',
    method: 'post',
    data,
    customTips: true,
});
